import { render, staticRenderFns } from "./EvolutionDashboard.vue?vue&type=template&id=c2044f80&scoped=true&"
import script from "./EvolutionDashboard.vue?vue&type=script&lang=js&"
export * from "./EvolutionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionDashboard.vue?vue&type=style&index=0&id=c2044f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2044f80",
  null
  
)

export default component.exports